import { useEffect } from "react";
import { usePatchPropertyCottageMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyCottageMutation";
import type { ClientPropertyCottageDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getCottageFormSchema } from "web_myplann/Portfolio/Forms/CottageForm/cottageFormSchema";
import { mapPropertyToCottageForm } from "web_myplann/Portfolio/Forms/CottageForm/mapPropertyToCottageForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditCottageFormArgs = {
	propertyId: number;
	property: ClientPropertyCottageDetailResponseDTO;
	detailRoute: string;
};

export const useEditCottageForm = ({
	propertyId,
	property,
	detailRoute,
}: UseEditCottageFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPropertyCottageMutation(propertyId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getCottageFormSchema(t),
		defaultValues: mapPropertyToCottageForm(property),
		mutate,
		successToast: t(Resources.Portfolio.EditRealEstate.savedToast, {
			type: t(Resources.Portfolio.AddRealEstate.Types.Cottage),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
